import React from "react";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  const terms = [
    {
      title: "1. Acceptance of Terms",
      text: "By registering, subscribing, or using UPSC Titan Score, you acknowledge that you have read, understood, and agreed to these Terms & Conditions."
    },
    {
      title: "2. User Account Responsibility",
      text: "Users are responsible for maintaining the confidentiality of their login credentials and for all activities performed under their account."
    },
    {
      title: "3. Subscription & Access",
      text: "Premium access is granted only after successful payment and is valid for the selected subscription period. Access may be restricted after subscription expiry unless renewed."
    },
    {
      title: "4. Intellectual Property",
      text: "All study materials, learning structures, mock content, UI design, educational frameworks, and premium resources available on the platform are the intellectual property of UPSC Titan Score unless otherwise stated."
    },
    {
      title: "5. Prohibited Activities",
      text: "Users must not copy, reproduce, redistribute, scrape, misuse, reverse engineer, or attempt unauthorized access to platform content, systems, or user data."
    },
    {
      title: "6. Limitation of Liability",
      text: "UPSC Titan Score provides educational preparation support and does not guarantee examination results, selection, rank, or interview performance. Platform use is at the user's own discretion."
    },
    {
      title: "7. Modifications to Terms",
      text: "We reserve the right to update or revise these Terms & Conditions at any time. Continued use of the platform after updates constitutes acceptance of the revised terms."
    }
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(168,85,247,0.08), transparent 22%), radial-gradient(circle at top right, rgba(56,189,248,0.08), transparent 24%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        color: "#fff"
      }}
    >
      <div className="container py-5">
        <div className="text-center mb-5">
          <div style={badgeStyle}>PLATFORM TERMS</div>

          <h1
            className="fw-bold mt-4"
            style={{
              fontSize: "clamp(2rem, 5vw, 3.2rem)",
              background: "linear-gradient(90deg, #ffffff, #cbd5e1, #38bdf8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            Terms & Conditions
          </h1>

          <p
            className="mx-auto mt-3"
            style={{
              maxWidth: "900px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              fontSize: "1.03rem"
            }}
          >
            Please read these Terms & Conditions carefully before using UPSC
            Titan Score. By accessing or using the platform, you agree to these
            terms.
          </p>
        </div>

        <div className="row g-4">
          {terms.map((item, index) => (
            <div className="col-12" key={index}>
              <div style={sectionCardStyle}>
                <h4 className="fw-bold mb-3" style={{ color: "#f8fafc" }}>
                  {item.title}
                </h4>
                <p style={textStyle}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 text-center" style={ctaStyle}>
          <div style={badgeStyle}>USER AGREEMENT</div>
          <h4 className="fw-bold mt-3 mb-3" style={{ color: "#ffffff" }}>
            Premium Access Comes With Responsible Use
          </h4>
          <p
            className="mx-auto"
            style={{
              maxWidth: "860px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              marginBottom: "22px"
            }}
          >
            By continuing to use UPSC Titan Score, you acknowledge and agree to
            abide by these Terms & Conditions as part of your platform usage.
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Link to="/privacy" className="btn btn-outline-light btn-lg px-4">
              Privacy Policy
            </Link>
            <Link to="/disclaimer" className="btn btn-success btn-lg px-4">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const badgeStyle = {
  display: "inline-block",
  padding: "8px 16px",
  borderRadius: "999px",
  background: "rgba(56,189,248,0.12)",
  border: "1px solid rgba(56,189,248,0.20)",
  color: "#7dd3fc",
  fontWeight: 700,
  fontSize: "13px",
  letterSpacing: "1px"
};

const sectionCardStyle = {
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.92), rgba(17,24,39,0.88))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "24px",
  padding: "26px",
  boxShadow: "0 14px 34px rgba(0,0,0,0.24)"
};

const textStyle = {
  color: "#94a3b8",
  lineHeight: "1.9",
  fontSize: "0.98rem",
  marginBottom: 0
};

const ctaStyle = {
  background:
    "linear-gradient(145deg, rgba(2,6,23,0.96), rgba(15,23,42,0.92))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "30px",
  padding: "42px 24px",
  boxShadow: "0 18px 40px rgba(0,0,0,0.28)"
};